<template>
  <section>
    <span>
      <img :src="getImgUrl(iconId)" :alt="heading" /><h1>{{heading}}</h1>
    </span>
    <checkbox :item-id="checkboxItemId" :responsive-label="true" :label="checkboxLabel" :label-active="checkboxLabelActive" />
  </section>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue'
export default {
  name: 'TileHeader',
  props: {
    checkboxItemId: String,
    heading: String,
    iconId: {
      type: String,
      default: 'placeholder',
      required: false
    },
    checkboxLabel: {
      type: String,
      default: 'hinzufügen',
      required: false
    },
    checkboxLabelActive: {
      type: String,
      default: 'hinzugefügt',
      required: false
    }
  },
  methods: {
    getImgUrl (icon) {
      var images = require.context('../assets/img/icons/items/', false, /\.svg$/)
      return images('./' + icon + '.svg')
    }
  },
  /*
  computed: {
    xyz: function () {
      return this.dependendItems
    },
    abc: function () {
      return this.getItemByID(this.checkboxItemId)
    }
  },
  */
  components: {
    Checkbox
  }
  /*
  ,
  methods: {
    getItemByID: function (itemId) {
      return this.$root.getItemByID(itemId)
    }
  },
  watch: {
    abc: function (state) {
      if (state === true) {
        alert('Its true!')
      } else {
        alert('Its false!')
      }
    }
  }
  */
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  margin: 30px 15px 10px 15px;
  padding: 20px 20px;
  span {
    display: flex;
    align-items: center;
  }
  img {
    width: 36px;
    height: 36px;
    margin-right: 8px;
    border-radius: 8px;
  }
  h1 {
    font-family: $primaryFont;
    font-weight: $primaryFontBold;
    color: $primaryFontColor;
    font-size: 18px;
    hyphens:auto;
    margin: 0 8px 0 0;
    line-height: 1.1;
  }
}
@media(min-width:360px) {
  section {
    h1 {
      font-size: 24px;
    }
  }
}
@media(min-width:767px) {
  section {
    margin: 40px 40px 15px 40px;
    img {
      width: 42px;
      height: 42px;
      margin-right: 12px;
    }
    h1 {
      font-size: 26px;
    }
    span {
      // transform: scale(1.2);
    }
  }
}
</style>
